import { render, staticRenderFns } from "./parcel_offloading.vue?vue&type=template&id=3edbc8c8&"
import script from "./parcel_offloading.vue?vue&type=script&lang=js&"
export * from "./parcel_offloading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports